import React, { Component } from "react";
import { connect } from "react-redux";

import { messageActions } from "../actions";
import { CloseIcon } from "../utils/components/icons";

class Message extends Component {
  handleCloseMessage() {
    this.props.dispatch(messageActions.closeMessage());
  }

  render() {
    setTimeout(() => {
      const infomsgbox = document.querySelector(".ser-infomsg.ser-modal button");
      if (infomsgbox) {
        infomsgbox.focus();
      }
    },
      200
    );
    return (
      <div className={"ser-infomsg ser-modal ser-fadein" + (this.props.messageStorage.hidden ? ' ser-outfaded' : '')}>
        <div className="ser-infomsgbox ser-modalbox">
          {!this.props.messageStorage.hidden
            ? <>
              <button type="button"
                title="Schließen"
                className="btn btn-link ser-close-modal"
                onClick={this.handleCloseMessage.bind(this)}
              >
                <CloseIcon></CloseIcon>
              </button>
              <span>{this.props.messageStorage.text}</span>
            </>
            : null
          }
        </div>
      </div>
    );
  }
};
export default connect((store) => {
  return {
    messageStorage: store.messageStorage
  };
})(Message);
